export const SET_CONSOLIDATED_VIEW = 'SET_CONSOLIDATED_VIEW';

export const setConsolidatedView = consolidatedView => ({
  type: SET_CONSOLIDATED_VIEW,
  payload: consolidatedView,
});
